import React from 'react';
import PropTypes from 'prop-types';
import green from '@material-ui/core/colors/green';
import grey from '@material-ui/core/colors/grey';
import blue from '@material-ui/core/colors/blue';
import { withStyles } from '@material-ui/core/styles';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';

const styles = () => ({
  colorBar: {},
  colorChecked: {},
  colorSwitchBase: {
    color: grey[300],
    '& + $colorBar': {
      backgroundColor: grey[600],
    },
    '&$colorChecked': {
      color: green[500],
      '& + $colorBar': {
        backgroundColor: green[500],
      },
    },
  },
  blueSwitchBase: {
    color: grey[300],
    '& + $colorBar': {
      backgroundColor: grey[600],
    },
    '&$colorChecked': {
      color: blue[500],
      '& + $colorBar': {
        backgroundColor: blue[500],
      },
    },
  },
  largeLabel: {
    fontSize: 25,
  },
  label: {},
  root: {
    marginLeft: 0,
    marginRight: 0,
  },
});

const Toggle = ({
  classes,
  color,
  label,
  labelPlacement,
  largeLabel,
  onToggle,
  title,
  toggled,
  ...others
}) => (
  <FormControlLabel
    classes={{
      root: classes.root,
      label: largeLabel ? classes.largeLabel : classes.label,
    }}
    control={
      <Switch
        checked={toggled}
        classes={{
          bar: classes.colorBar,
          checked: classes.colorChecked,
          switchBase: color === 'blue' ? classes.blueSwitchBase : classes.colorSwitchBase,
        }}
        onChange={onToggle}
        value={title}
      />
    }
    label={label}
    labelPlacement={labelPlacement}
    {...others}
  />
);

Toggle.propTypes = {
  classes: PropTypes.shape({}).isRequired,
  color: PropTypes.string,
  label: PropTypes.string,
  labelPlacement: PropTypes.string,
  largeLabel: PropTypes.bool,
  onToggle: PropTypes.func.isRequired,
  title: PropTypes.string,
  toggled: PropTypes.bool.isRequired,
};

Toggle.defaultProps = {
  color: '',
  label: '',
  labelPlacement: 'start',
  largeLabel: false,
  title: '',
};

export default withStyles(styles)(Toggle);
